import { call, select, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionById, getGrusername } from '../selectors';
import { requestNapi, requestPuppy } from '@wix/da-http-client';
import { getGallectionType } from '../helpers';
import { flagEnabled } from '@wix/da-react-context/pkg/flags/redux/selectors';
function* setChangedGallectionPrice(action) {
    yield delay(500); // + takeLatest = debounced
    const { folderId, pointsPrice } = action.payload;
    const gallection = yield select(getGallectionById, folderId);
    const username = yield select(getGrusername);
    if (!gallection) {
        return;
    }
    var _getGallectionType, _gallection_description;
    const params = {
        username,
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: gallection.folderId,
        name: gallection.name,
        description: (_gallection_description = gallection.description) !== null && _gallection_description !== void 0 ? _gallection_description : undefined,
        cover_deviationid: gallection.type === 'stash' ? undefined : get(gallection, 'thumb.deviationId'),
        points_price: pointsPrice
    };
    const isEditorGallection = yield select(flagEnabled, 'editor_gallection');
    if (isEditorGallection) {
        yield call(requestNapi, {
            method: 'post',
            url: 'gallection/folders/update',
            data: params
        }, undefined);
    } else {
        yield call(requestPuppy, {
            method: 'post',
            url: 'gallection/folders/update',
            data: params
        });
    }
}
export default setChangedGallectionPrice;

//# sourceMappingURL=saveChangedGallectionPrice.js.map